import { useQuery } from '@tanstack/react-query';
import { request } from '@core/api/request';
import type { TApiResponse } from '@shared/types';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { TEwallet } from '@shared/types/ewallet';

export const getEWallet = async (): Promise<TApiResponse<TEwallet>> => {
  return request({
    url: 'ewallets/',
  });
};

export const useEWallet = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.getEWallet],
    queryFn: async () => await getEWallet(),
  });
};
